import apiClient from './apiClient';

export default {
  fetchItemsController: null,
  fetchItemController: null,
  fetchItems({ params }) {
    this.fetchItemsController?.abort();
    this.fetchItemsController = new AbortController();
    const { signal } = this.fetchItemsController;
    return apiClient.get('/admin/workouts', { params, signal });
  },
  fetchItem({ id }) {
    this.fetchItemController?.abort();
    this.fetchItemController = new AbortController();
    const { signal } = this.fetchItemController;
    return apiClient.get(`/admin/workouts/${id}`, { signal })
      .catch((err) => {
        if (err?.message !== 'canceled') {
          return Promise.reject(err);
        }
      });
  },
  createItem: ({ data }) => apiClient.post('/admin/workouts', data),
  updateItem: ({ id, data }) => apiClient.put(`/admin/workouts/${id}`, data),
  // deleteItem: ({ id }) => apiClient.delete(`/admin/workouts/${id}`),

  fetchWorkoutTypes: () => apiClient.get('/admin/workouts/types'),

  changeVisibility: ({ id, data }) => apiClient.post(`/admin/workouts/${id}/change_visibility`, data),

  updateImg: ({ type, data, params }) => apiClient.put(`/admin/workouts/image/${type}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    params,
  }),
};
